import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shipment-files-toolbar" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "shipment-files-status-panel"
}
const _hoisted_4 = { class: "shipment-files-status-copy" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "shipment-files-progress-shell",
  "aria-live": "polite"
}
const _hoisted_8 = {
  key: 2,
  class: "shipment-files-error"
}
const _hoisted_9 = {
  key: 3,
  class: "shipment-files-empty"
}
const _hoisted_10 = {
  key: 4,
  class: "shipment-files-empty"
}
const _hoisted_11 = {
  key: 5,
  class: "shipment-files-list scroll-content"
}
const _hoisted_12 = ["tabindex", "onClick", "onKeydown"]
const _hoisted_13 = { class: "shipment-file-main" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "shipment-file-thumbnail-label"
}
const _hoisted_16 = { class: "shipment-file-copy" }
const _hoisted_17 = ["disabled", "title", "onClick"]
const _hoisted_18 = { class: "shipment-file-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverflowMenu = _resolveComponent("OverflowMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['shipment-files-pane', { 'is-drag-over': _ctx.isDragOver }]),
    onDragenter: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
    onDragover: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
    onDragleave: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"])),
    onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "shipment-files-dropzone",
        disabled: !_ctx.tracking || _ctx.isUploading,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerUploadInput && _ctx.triggerUploadInput(...args)))
      }, [...(_cache[7] || (_cache[7] = [
        _createStaticVNode("<span class=\"shipment-files-dropzone-icon\"><i class=\"material-icons\">attach_file</i></span><span class=\"shipment-files-dropzone-copy\"><span class=\"shipment-files-dropzone-text\">Drag and Drop or <span class=\"shipment-files-dropzone-link\">Choose File</span></span><small>Supported: images, PDF, XLSX, CSV, TXT. Max 10 MB each.</small></span>", 2)
      ]))], 8 /* PROPS */, _hoisted_2),
      _createElementVNode("input", {
        ref: "uploadInputRef",
        type: "file",
        class: "shipment-files-hidden-input",
        multiple: "",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUploadInputChange && _ctx.handleUploadInputChange(...args)))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
      _createElementVNode("input", {
        ref: "replaceInputRef",
        type: "file",
        class: "shipment-files-hidden-input",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleReplaceInputChange && _ctx.handleReplaceInputChange(...args)))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
    ]),
    (_ctx.isUploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isUploading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.uploadStatusLabel), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Drop files to upload")),
            _cache[8] || (_cache[8] = _createElementVNode("small", null, "Supported: images, PDF, XLSX, CSV, TXT. Max 10 MB each.", -1 /* CACHED */))
          ]),
          (_ctx.isUploading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "shipment-files-progress-bar",
                  style: _normalizeStyle({ width: `${_ctx.uploadProgressPercent}%` })
                }, null, 4 /* STYLE */)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.bannerMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['shipment-files-banner', `is-${_ctx.bannerTone}`])
        }, _toDisplayString(_ctx.bannerMessage), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading files…"))
      : (_ctx.files.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No files attached yet."))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file.id,
                class: "shipment-file-row",
                role: "button",
                tabindex: file.status === 'ready' ? 0 : -1,
                onClick: ($event: any) => (_ctx.handleRowOpen(file)),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (_ctx.handleRowOpen(file)), ["prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.handleRowOpen(file)), ["prevent"]), ["space"])
                ]
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['shipment-file-thumbnail', `is-${_ctx.getPreviewKind(file)}`])
                  }, [
                    (_ctx.thumbnailUrls[file.id])
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.thumbnailUrls[file.id],
                          alt: `${file.displayName} preview`,
                          class: "shipment-file-thumbnail-image",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, _hoisted_14))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getPreviewLabel(file)), 1 /* TEXT */))
                  ], 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "shipment-file-name shipment-file-open-link",
                      disabled: file.status !== 'ready',
                      title: file.displayName,
                      onClick: _withModifiers(($event: any) => (_ctx.handleMenuDownload(file)), ["stop"])
                    }, _toDisplayString(file.displayName), 9 /* TEXT, PROPS */, _hoisted_17),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatType(file)), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.sizeBytes)), 1 /* TEXT */),
                      _createElementVNode("span", null, "v" + _toDisplayString(file.version), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(file.updatedAt)), 1 /* TEXT */)
                    ])
                  ])
                ]),
                (_openBlock(), _createBlock(_component_OverflowMenu, {
                  key: `${file.id}-${_ctx.fileMenuRenderKey}`,
                  class: "action-menu-wrapper shipment-file-actions-menu",
                  "button-label": "File actions",
                  disabled: _ctx.isUploading,
                  portal: true,
                  placement: "top",
                  "trigger-class": ['action-menu-trigger', 'action-buttons', 'shipment-file-menu-trigger'],
                  options: _ctx.getFileMenuOptions(file),
                  onSelect: ($event: any) => (_ctx.handleFileMenuSelect($event, file))
                }, {
                  trigger: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "material-icons" }, "more_horiz", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "options", "onSelect"]))
              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
  ], 34 /* CLASS, NEED_HYDRATION */))
}